import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-signin',
  templateUrl: './nav-signin.component.html',
  styleUrls: ['./nav-signin.component.scss']
})
export class NavSigninComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/navbar/nav-signin/nav-signin.component.ts